export const errorFixDialogFormInitialValues = {
  email: '',
  lawftAccess: false,
  phoneNumber: '',
  billingContacts: [],
};

export const FIX_ERROR = 'Fix Error';
